import React from "react"

function NewsTicker() {
  return (
    <div className="news-ticker relative md:top-0 top-[1rem] bg-red-600 text-white uppercase w-full h-10 overflow-hidden flex flex-col justify-start items-center ">
      <p>WE ARE OPEN ON NEW YEAR{"'"}S EVE SUNDAY</p>
      <p>11:00AM to 5:00pm THIS SUNDAY</p>
      <p>Start the New Year with More Cash!</p>
    </div>
  )
}

export default NewsTicker
